import * as React from 'react';
import {useSelector} from 'react-redux';

import {Field} from 'redux-form';

import {Assignables} from 'nutshell-core/assignables';

import {FormField} from 'shells/form/form-field';

import {AssigneeSelect} from './assignee-select';
import {AUTO_ASSIGN_OPTION} from './consts';

type Props = {
    fieldKey: string;
    isRequired: boolean;
    validate: (...args: any) => any;
    isDisabled: boolean;
    showAutoAssign?: boolean;
};

export function AssigneeSelectField(props: Props) {
    const assignables = useSelector(Assignables.getAllEnabled);

    // @ts-expect-error
    const options = props.showAutoAssign ? [AUTO_ASSIGN_OPTION, ...assignables] : assignables;

    return (
        <FormField
            key={props.fieldKey}
            innerId={props.fieldKey}
            isRequired={props.isRequired}
            label='Assignee'
        >
            <Field
                name={props.fieldKey}
                component={AssigneeSelect}
                options={options}
                placeholder='Select an assignee'
                {...props}
            />
        </FormField>
    );
}
